import React, { Component } from 'react';
import logo from './logo.png';
import './App.css';
import * as moonSugar from 'moon-sugar';

class App extends Component {
    componentDidMount() {
        moonSugar.init({
            element: this.moon,
            classNameSnowflow: "moonSugar-item",
            countFlakesInSecons: 5,
            countFlakeTypes: 5
        })
    };

  render() {
    return (<div>
      <div className="logo">
          <img src={logo} alt="" />
      </div>

      <div className="description">
        <h2 className="description-title">
            What is it?
        </h2>

        <div>
          <p>It is a "Moon Sugar", library for snowfall on your website.</p>
        </div>
      </div>

        <div className="description">
            <h2 className="description-title">
                How to work with this?
            </h2>

            <div>
                <p>To initialize "Moon Sugar" you need add this library to your project:</p>
                <em>
                    //old school<br />
                    &#x3C;script src=&#x22;moon-sugar.min.js&#x22;&#x3E;&#x3C;/script&#x3E;<br /><br />
                    //new school<br />
                    //TODO: make a normal import<br />
                    import * as moonSugar from 'moon-sugar';
                </em>
                <p>Add element for snowflakes in your HTML</p>
                <em>
                    &#x3C;!DOCTYPE html&#x3E;<br />
                    &#x3C;html lang=&#x22;en&#x22;&#x3E;<br />
                    &#x3C;head&#x3E;<br />
                    &nbsp;&nbsp;&nbsp;&nbsp;&#x3C;meta charset=&#x22;UTF-8&#x22;&#x3E;<br />
                    &nbsp;&nbsp;&nbsp;&nbsp;&#x3C;title&#x3E;Title&#x3C;/title&#x3E;<br />
                    &#x3C;/head&#x3E;<br />
                    &#x3C;body&#x3E;<br />
                    <br />
                    &nbsp;&nbsp;&nbsp;&nbsp;&#x3C;div class=&#x22;moonSugar&#x22;&#x3E;&#x3C;/div&#x3E;<br />
                    &#x3C;/body&#x3E;<br />
                    &#x3C;/html&#x3E;<br />
                </em>
                <p>And run this:</p>
                <pre><code>
                    moonSugar.init();
                </code></pre>
                <p>You also need to add styles:</p>
                <em>
                    .moonSugar &#123;<br />
                    &nbsp;&nbsp;&nbsp;&nbsp;overflow: hidden;<br />
                    &nbsp;&nbsp;&nbsp;&nbsp;position: absolute;<br />
                    &nbsp;&nbsp;&nbsp;&nbsp;left: 0;<br />
                    &nbsp;&nbsp;&nbsp;&nbsp;top: 0;<br />
                    &nbsp;&nbsp;&nbsp;&nbsp;pointer-events: none;<br />
                    &#125;<br />
                    .moonSugar-item &#123;<br />
                    &nbsp;&nbsp;&nbsp;&nbsp;position: absolute;<br />
                    &nbsp;&nbsp;&nbsp;&nbsp;left: 0;<br />
                    &nbsp;&nbsp;&nbsp;&nbsp;top: 0;<br />
                    &nbsp;&nbsp;&nbsp;&nbsp;will-change: transform;<br />
                    &nbsp;&nbsp;&nbsp;&nbsp;width: 14px;<br />
                    &nbsp;&nbsp;&nbsp;&nbsp;height: 14px;<br />
                    &nbsp;&nbsp;&nbsp;&nbsp;background: url("path-to-image") center center/14px 14px no-repeat;<br />
                    &#125;<br />
                </em>
            </div>
        </div>

        <div className="description">
            <h2 className="description-title">
                What options can I use?
            </h2>

            <div>
                <p>You can use in init-method next options:</p>
                <ul>
                    <li>
                        <h3>element</h3>
                        <p>Root element. It's may be <b>Element</b> (example: <i>document.querySelector(".moonSugar")</i>) or <b>String</b> (example: <i>".moonSugar"</i>).</p>
                        <p>Default: <i>document.querySelector(".moonSugar")</i></p>
                    </li>
                    <li>
                        <h3>classNameSnowflow</h3>
                        <p>Class name for snowflake. <b>String</b> (example: <i>"moonSugar-item"</i>)</p>
                        <p>Default: <i>"moonSugar-item"</i></p>
                    </li>
                    <li>
                        <h3>countFlakesInSecons</h3>
                        <p>How many to generate snowflakes per second. <b>Number</b> (example: <i>10</i>). Attention: a large number can cause performance problems.</p>
                        <p>Default: <i>5</i></p>
                    </li>
                    <li>
                        <h3>countFlakeTypes</h3>
                        <p>How many to generate types of snowflakes. <b>Number</b> (example: <i>5</i>).</p>
                        <p>Default: <i>1</i></p>
                        <p>In this case you can set different types of snowflakes:</p>
                        <em>
                            .moonSugar-item[data-type="0"] &#123;<br />
                            &nbsp;&nbsp;&nbsp;&nbsp;background-image: url("path-to-image-0");<br />
                            &#125;<br />
                            .moonSugar-item[data-type="1"] &#123;<br />
                            &nbsp;&nbsp;&nbsp;&nbsp;background-image: url("path-to-image-1");<br />
                            &#125;<br />
                            .moonSugar-item[data-type="2"] &#123;<br />
                            &nbsp;&nbsp;&nbsp;&nbsp;background-image: url("path-to-image-2");<br />
                            &#125;<br />
                            .moonSugar-item[data-type="3"] &#123;<br />
                            &nbsp;&nbsp;&nbsp;&nbsp;background-image: url("path-to-image-3");<br />
                            &#125;<br />
                            .moonSugar-item[data-type="4"] &#123;<br />
                            &nbsp;&nbsp;&nbsp;&nbsp;background-image: url("path-to-image-4");<br />
                            &#125;<br />
                        </em>
                    </li>
                </ul>
            </div>
        </div>

        <div className="description">
            <h2 className="description-title">
                Where can I get images for snow?
            </h2>

            <div>
                <p>For example, you can get it <a href="https://www.flaticon.com/packs/snowflakes" target="_blank">from this</a>.</p>
            </div>
        </div>

        <div className="description">
            <h2 className="description-title">
                Wow, and where can I get this library?
            </h2>

            <div>
                <p>Welcome to <a href="https://github.com/HawkeyePierce89/Moon-Sugar" target="_blank">github</a>.</p>
                <p>Or you can install npm package</p>
                <em>
                    npm install moon-sugar
                </em>
            </div>
        </div>

        <div className="description">
            <h2 className="description-title">
                Thankfulness
            </h2>

            <div>
                <p>Many thanks <a href="https://twitter.com/inflashwetrust" target="_blank">@inflashwetrust</a> for the mathematical logic of flying snowflakes and help in professional development.</p>
            </div>
        </div>

        <div className="moonSugar" ref={(c) => this.moon = c} />
    </div>);
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js